import styled from 'styled-components'

export const Button = styled.button`
  position: absolute;
  right: 16px;
  // offset half of bottom margin to center correctly
  top: calc(50% - 10px);
  transform: translateY(-50%);
  border: 0;
  background: none;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

export const Icon = styled.img`
  display: block;
`

export const HelpMessage = styled.div`
  background-color: ${({ theme }) => theme.colors.brand.blue};
  color: ${({ theme }) => theme.colors.coolGray.cool150};
  text-align: left;
  position: absolute;
  width: 200px;
  font-size: 12px;
  line-height: 1.25;
  padding: 10px;
  border-radius: 4px;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0px 0px 10px -2px #000;
  z-index: 1000;
`

export const Arrow = styled.div`
  position: absolute;
  right: -5px;
  margin-top: -5px;
  top: 50%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 5px;
  border-color: transparent;
  border-left-color: ${({ theme }) => theme.colors.brand.blue};
`
